"use client";

import { useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";

const BASE_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

const verifyEmail = async (token: string) => {
	if (!BASE_URL) {
		return { success: false, message: "Missing backend URL" };
	}

	const res = await fetch(`${BASE_URL}/users/verify-email?token=${token}`, {
		method: "GET",
		cache: "no-store",
	});

	if (!res.ok) {
		return { success: false, message: "Unable to verify" };
	}

	const data = await res.json().catch(() => null);
	if (data?.code === 200) {
		return { success: true, message: "Email verified" };
	}

	return { success: false, message: data?.message ?? "Unable to verify" };
};

export const VerifyEmailClient = () => {
	const searchParams = useSearchParams();
	const router = useRouter();
	const token = searchParams?.get("token") ?? "";

	useEffect(() => {
		const runVerification = async () => {
			if (!token) {
				router.replace("/verify-email/result?status=missing");
				return;
			}

			const result = await verifyEmail(token);
			const status = result.success ? "success" : "error";
			router.replace(`/verify-email/result?status=${status}`);
		};

		runVerification();
	}, [router, token]);

	return null;
};
